var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".book-rank-overlay{align-items:center;background-repeat:no-repeat;background-size:cover;color:#fff;cursor:default;display:flex;position:absolute;right:0;text-align:center;text-transform:uppercase;top:0;z-index:1}.book-rank-overlay--small{background-image:url(" + escape(require("./files/ribbon-small.png")) + ");background-position:0 -5px;font-size:10.288px;font-size:0.643rem;height:33px;line-height:1;padding-bottom:8px;width:25px}.book-rank-overlay--medium{background-image:url(" + escape(require("./files/ribbon-medium.png")) + ");font-size:12.576px;font-size:0.786rem;height:60px;line-height:1.3;padding-bottom:5px;padding-left:-4px;width:45px}.book-rank-overlay--space{padding-left:4px}.book-rank-overlay__tooltip{max-width:250px;padding:5px 8px}@media print{.book-rank-overlay__ranking{display:none}}\n", ""]);

// exports
exports.locals = {
	"book-rank-overlay": "book-rank-overlay",
	"book-rank-overlay--small": "book-rank-overlay--small",
	"book-rank-overlay--medium": "book-rank-overlay--medium",
	"book-rank-overlay--space": "book-rank-overlay--space",
	"book-rank-overlay__tooltip": "book-rank-overlay__tooltip",
	"book-rank-overlay__ranking": "book-rank-overlay__ranking"
};